import React, { Component } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

export class FormPhoneLookup extends Component {
  state = {
    phoneInvalid: false
  };

  removeInvalid = () => {
    this.setState({
      phoneInvalid: false
    });
  };

  continue = e => {
    e.preventDefault();
    const { phone } = this.props.values;
    console.debug(phone);
    if (phone === null || phone === "" || phone.length < 17) {
      this.setState({
        phoneInvalid: true
      });
    } else {
      this.props.nextStep();
    }
  };

  render() {
    const { values, handleChange } = this.props;
    const environment = process.env.REACT_APP_ENVIRONMENT;
    return (
      <React.Fragment>
        <h3>Service Appointment</h3>
        <h5>Let's start with your phone</h5>
        <hr />
        <Row>
          <Col>
            <Form onSubmit={this.continue}>
              <Form.Group controlId="formPhone">
                <Form.Control
                  type="tel"
                  name="phone"
                  className={"bfh-phone " + (this.state.phoneInvalid ? "is-invalid" : "")}
                  data-country="US"
                  placeholder="Phone Number"
                  autoComplete="tel"
                  defaultValue={values.phone}
                  autoFocus={true}
                  onChange={e => {
                    this.removeInvalid();
                    handleChange({
                      [e.target.name]: e.target.value
                    });
                  }}
                />
                {this.state.phoneInvalid && <Form.Label>We cannot book an appointment unless we have your phone number</Form.Label>}
              </Form.Group>

              <Form.Group controlId="formSendReminders">
                <Form.Check
                  name="optedIn"
                  type="checkbox"
                  defaultChecked={values.optedIn}
                  onChange={e =>
                    handleChange({
                      optedIn: e.target.checked
                    })
                  }
                  label="Send me reminders and occasional coupons via SMS on this number"
                />
                <Form.Label className="text-smaller">
                  By entering your mobile # and checking above checkbox, you are agreeing to receive up to 3 reminders and/or marketing messages per month from us at your phone #. Your consent is not
                  a condition of making any purchase. Message and data rates may apply.
                </Form.Label>
              </Form.Group>

              <Button size="lg" block variant={environment !== "production" ? "warning" : "primary"} type="submit">
                Lookup
                {environment !== "production" && " [" + environment + "]"}
              </Button>
            </Form>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default FormPhoneLookup;
